import { render } from "./FeasibilityProjects.vue?vue&type=template&id=5f8cbbdf&scoped=true"
import script from "./FeasibilityProjects.vue?vue&type=script&lang=js"
export * from "./FeasibilityProjects.vue?vue&type=script&lang=js"

import "./FeasibilityProjects.vue?vue&type=style&index=0&id=5f8cbbdf&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/user.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8cbbdf"]])

export default __exports__